import { render, staticRenderFns } from "./createactivity.vue?vue&type=template&id=e2f0d91c"
import script from "./createactivity.vue?vue&type=script&lang=js"
export * from "./createactivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports